import React from 'react';
const Newsletter = () => {
  return <div className="container mx-auto px-4" data-id="element-129">
      <div className="bg-beige p-8 rounded-lg shadow-md" data-id="element-130">
        <div className="text-center" data-id="element-131">
          <h2 className="text-2xl font-bold text-brown mb-4" data-id="element-132">
            Join Our Newsletter
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-133">
            Stay updated with the latest baby nutrition tips, product releases,
            and exclusive offers.
          </p>
          <form className="max-w-md mx-auto" data-id="element-134">
            <div className="flex flex-col sm:flex-row gap-2" data-id="element-135">
              <input type="email" placeholder="Your email address" className="flex-grow px-4 py-3 rounded-full focus:outline-none focus:ring-2 focus:ring-brown" required data-id="element-136" />
              <button type="submit" className="bg-brown text-cream px-6 py-3 rounded-full hover:bg-brown-dark transition-colors duration-300" data-id="element-137">
                Subscribe
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
};
export default Newsletter;